import './TrainWithReach360Dialog.scss'

import Button from 'lib/components/Button/Button'
import Dialog from 'lib/components/Dialog/Dialog'
import ActionDialog from 'pages/Home/admin/ActionDialog/ActionDialog'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

const { ARTICULATE_DOMAIN } = process.env

export interface TrainErrorDialogProps {
  onRequestClose: ()=> void
}

const TrainWithReach360ErrorDialog = ({ onRequestClose }: TrainErrorDialogProps) => {
  const [t] = useTranslation()

  return (
    <Dialog className="alt-dialog-modal" focusTrap onRequestClose={onRequestClose} type="warning">
      <Dialog.Header className="alt-dialog-header" onRequestClose={onRequestClose}>
        <Dialog.Title className="alt-dialog-header-title">
          {t('trainWithReach360Error.header')}
        </Dialog.Title>
      </Dialog.Header>
      <ActionDialog.Body className="alt-content">
        <strong className="alt-description">
          <Trans i18nKey="trainWithReach360Error.body" t={t} >
            Please try again, and <a href={`https://${ARTICULATE_DOMAIN}/support`} target="_blank">contact support</a> if you need help.
          </Trans>
        </strong>
      </ActionDialog.Body>
      <ActionDialog.Footer className="alt-dialog-footer">
        <Button autoFocus className="continue-button" onClick={onRequestClose}>
          {t('trainWithReach360Error.buttons.close')}
        </Button>
      </ActionDialog.Footer>
    </Dialog>
  )
}

export default TrainWithReach360ErrorDialog
